import type { ExportData } from '@/hooks/exportDropdown/types'
import { getBlockContentText } from '@/utils'
import type { ContentBlockRow, ContentRow } from '../types'

export const normalizeExportData = (
  pageGroups: ExportData[][]
): ContentRow[] => {
  const collect = (pages: ExportData[], parent = ''): ContentRow[] => {
    return pages.flatMap((page, index) => {
      const pageNumber: string = `${parent}${index + 1}.`
      const { title, blocks = [], children = [], url = '', notes = {} } = page

      const {
        seoTitle = '',
        seoSlug = '',
        seoDescription = '',
        keywords = '',
        pageIntent = '',
      } = notes

      const blockRows: ContentBlockRow[] = blocks.map((block) => ({
        title: block.title,
        text: getBlockContentText(block.content) || null,
      }))

      const current: ContentRow = {
        number: pageNumber,
        title,
        block: blockRows,
        url,
        seoTitle,
        slug: seoSlug,
        description: seoDescription,
        keywords,
        pageIntent,
      }

      return [current, ...collect(children, pageNumber)]
    })
  }

  return pageGroups.flatMap((group) => collect(group))
}
